import {
  AuthTokenStorageValue,
} from '@/plugins/auth-token-storage';

export enum AuthCookieKeys {
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  TOKEN_TYPE = 'token_type',
  EXPIRY = 'expiry',
}

export function hasAuthDataInLocation(): boolean {
  const searchParams = new URLSearchParams(location.search);

  return [
    searchParams.has(AuthCookieKeys.ACCESS_TOKEN),
    searchParams.has(AuthCookieKeys.REFRESH_TOKEN),
    searchParams.has(AuthCookieKeys.TOKEN_TYPE),
    searchParams.has(AuthCookieKeys.EXPIRY),
  ].some(Boolean);
}

export function getAuthDataInLocation(): AuthTokenStorageValue {
  const searchParams = new URLSearchParams(location.search);

  return {
    [AuthCookieKeys.ACCESS_TOKEN]: searchParams.get(AuthCookieKeys.ACCESS_TOKEN) || '',
    [AuthCookieKeys.REFRESH_TOKEN]: searchParams.get(AuthCookieKeys.REFRESH_TOKEN) || '',
    [AuthCookieKeys.TOKEN_TYPE]: searchParams.get(AuthCookieKeys.TOKEN_TYPE) || '',
    [AuthCookieKeys.EXPIRY]: searchParams.get(AuthCookieKeys.EXPIRY) || '',
  };
}

export function redirectToAuthPage(redirectTo?: string): void {
  const link = redirectTo || location.origin;

  location.replace(`${__config.url.default}?redirect_to=${link}`);
}
